(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-melden-mega]').forEach(function (mega) {
    var sheet = mega.querySelector('[data-melden-mega-sheet]');
    if (!sheet) return;
    var openTimer = null;
    var closeTimer = null;

    function isDesktop() {
      return window.matchMedia('(min-width: 750px)').matches;
    }

    function activate(kind) {
      mega.querySelectorAll('[data-melden-mega-panel]').forEach(function (panel) {
        panel.classList.toggle('melden-mega__panel--active', panel.getAttribute('data-melden-mega-panel') === kind);
      });
    }

    function show(kind) {
      activate(kind);
      mega.classList.add('melden-mega--open');
      document.documentElement.classList.add('melden-nav-overlay-open');
      sheet.setAttribute('aria-hidden', 'false');
    }

    function hide() {
      mega.classList.remove('melden-mega--open');
      document.documentElement.classList.remove('melden-nav-overlay-open');
      sheet.setAttribute('aria-hidden', 'true');
    }

    function scheduleOpen(kind) {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      if (mega.classList.contains('melden-mega--open')) {
        show(kind);
      } else {
        openTimer = setTimeout(function () { show(kind); }, 70);
      }
    }

    function scheduleClose() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(hide, 260);
    }

    mega.querySelectorAll('[data-melden-mega-trigger]').forEach(function (trigger) {
      var kind = trigger.getAttribute('data-melden-mega-trigger');

      trigger.addEventListener('pointerenter', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        if (!isDesktop()) return;
        if (kind === 'none') scheduleClose();
        else scheduleOpen(kind);
      });

      trigger.addEventListener('pointerleave', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        scheduleClose();
      });

      trigger.addEventListener('focus', function () {
        if (!isDesktop()) return;
        if (kind === 'none') hide();
        else show(kind);
      });
    });

    sheet.addEventListener('pointerenter', function () {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
    });

    sheet.addEventListener('pointerleave', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      scheduleClose();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
    });

    document.addEventListener('click', function (e) {
      if (!mega.contains(e.target)) hide();
    });

    window.addEventListener('resize', function () {
      if (!isDesktop()) hide();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
